module.exports = __webpack_public_path__ + "img/exclamation-mark.562ca105.svg";